/*
Composable useShowDashboardSidebar handles the global state of showing
navigation sidebar. The composable is used within the navigation controls.
*/
export const useShowDashboardSidebar = () => {
  const showSidebar = useState('showSidebar', () => <boolean>false)
  const currentSubMenu = useState('currentSubMenu', () => <string | null>null)

  const toggleShowSidebar = () => {
    showSidebar.value = !showSidebar.value
  }

  const showSidebarVisible = () => {
    resetCurrentSubMenu()
    showSidebar.value = true
  }

  const setSidebarHidden = () => {
    showSidebar.value = false
  }

  const setCurrentSubMenu = (subMenu: string) => {
    resetCurrentSubMenu()
    setSidebarHidden()
    currentSubMenu.value = subMenu
  }

  const resetCurrentSubMenu = () => {
    currentSubMenu.value = null
  }

  return { showSidebar, toggleShowSidebar, showSidebarVisible, setSidebarHidden, currentSubMenu, setCurrentSubMenu, resetCurrentSubMenu }
}
